import React, { useContext, useEffect, useState } from "react";
import {
  Box,
  FormControl,
  FormLabel,
  HStack,
  Img,
  Input,
  Stack,
  Text,
  SlideFade,
  useColorModeValue,
  Alert,
  AlertIcon,
  AlertDescription,
  Modal,
  ModalOverlay,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalContent,
  Spinner,
  Select,
  InputGroup,
  InputLeftElement,
  Button,
  Icon,
} from "@chakra-ui/react";
import { AiOutlineCloudUpload, AiOutlinePhone, AiOutlineInfoCircle } from "react-icons/ai";
import { COLORS } from "../../../constants/colors";
import { PROTECTED_PATHS } from "../../../app/constants";
import {
  errorNotifier,
  infoNotifier,
  successNotifier,
} from "../../../components/NotificationHandler";
import Container from "../../../components/Container";
import Header from "../../../components/Header";
import { PrimaryButton } from "../../../components/CustomButton";
import {fetchStreetsData } from "../../signup/service/signup";
import { AuthContext } from "../../../context/authContext";
import { formLabelStyles } from "../../issue report/components/issueReportData";
import PaystackModal from "./PaystackModal";
import ConfirmCardPayment from "./ConfirmCardPayment";
import axiosInstance from "../../../services/api";
import { useNavigate, useLocation } from "react-router-dom";
import { getUserProfile } from "../../settings/service/getUserProfile";

const RequestId = ({ onClose }) => {
  const appTextColor = useColorModeValue(COLORS.black, COLORS.white);
  const cardBg = useColorModeValue(COLORS.primary, COLORS.white);
  const [loading, setLoading] = useState(false);
  const { ID_CARD } = PROTECTED_PATHS;
  const serviceCharge = "4,100";
  const { userInfo } = useContext(AuthContext);
  const [family, setFamily] = useState([]);
  const [media, setMedia] = useState(null);
  const [userProfile, setUserProfile] = useState(false);
  const [paymentData, setPaymentData] = useState({});
  const [paymentModal, setPaymentModal] = useState(false);
  const [paymentLoading, setPaymentLoading] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formValues, setformValues] = useState({
    name: "",
    streetId: "",
    houseNumber: "",
    tenantName: "",
    tenantPhone: "",
    email: "", // optional
    designation: "", // optional
  });
  const [streetsData, setStreetsData] = useState({});
  const [loadingStreets, setLoadingStreets] = useState(true);
  const [displayHouseNumber, setDisplayHouseNumber] = useState("");
  const [showTerms, setShowTerms] = useState(true);

  // const location = useLocation();
  // const data = location.state?.data?.tenant || location.state || {};
  // const userId = data._id || "";
  // const email = data.email || "No email provided";
  // const houseNumber =
  //   data.houseId.estate[0].houseNumber || "No house number available";
  // const streetName = data.streetId.streetName || "No house number available";
  // const tenantName = data.tenantName || "No tenant name available";
  // const phoneNumber = data.tenantPhone || "No tenant name available";

  const handleChange = (e) => {
    const { name, value } = e.target;
    setformValues((prev) => ({ ...prev, [name]: value }));
  };

  // useEffect(() => {
  //   getUserProfile(userId, setLoading, setUserProfile);
  //   getFamily(userId, setLoading, setFamily);
  // }, [userId]);

  useEffect(() => {
    const loadStreetsData = async () => {
      try {
        await fetchStreetsData(
          (data) => {
            setStreetsData(data.streets || {});
          },
          (loading) => {
            setLoadingStreets(loading);
          }
        );
      } catch (error) {
        errorNotifier("Could not load streets data.");
      }
    };
    loadStreetsData();
  }, []);

  const navigate = useNavigate();

  const handleImage = (event) => {
    if (!event.target.files) return;

    const file = event.target.files[0];
    const acceptedFormats = ["image/png", "image/jpeg", "image/jpg"];

    if (!acceptedFormats.includes(file.type)) {
      infoNotifier("Please upload a valid image file (PNG, JPEG, JPG)");
      return;
    }

    setMedia(file);
  };

  const handleStreetChange = (e) => {
    const selectedStreetId = e.target.value;
    setformValues((prev) => ({
      ...prev,
      streetId: selectedStreetId,
      houseId: "",
    }));
    setDisplayHouseNumber("");
  };

  const handleHouseChange = (e) => {
    const selectedHouse = e.target.value;
    setDisplayHouseNumber(selectedHouse);

    const house = streetsData[formValues.streetId]?.houses.find(
      (h) => h.number === selectedHouse
    );
    if (house) {
      setformValues((prev) => ({
        ...prev,
        houseId: house.id,
      }));
    }
  };

  const handleSubmit = async () => {
    setIsSubmitting(true);
    setLoading(true);
    const formData = new FormData();

    const selectedStreet = Object.entries(streetsData)
      .find(([id]) => id === formValues.streetId)?.[1]?.streetName || '';
    const selectedHouse = displayHouseNumber; // We already have the house number in this state

    formData.append("name", formValues.tenantName);
    formData.append("phoneNumber", formValues.tenantPhone);
    formData.append("passport", media);
    formData.append("houseNumber", formValues.houseNumber);
    formData.append("street", selectedStreet);
    if (formValues.email) formData.append("email", formValues.email);
    formData.append("paymentReference", paymentData?.reference);


   try {
  await axiosInstance.post("/card/temp-request", formData);
  successNotifier("Request submitted successfully!");
  window.location.reload();
} catch (error) {
  errorNotifier(
    error.response?.data?.result?.message ||
    error.response?.data?.message ||
    error.message ||
    "Failed to Send Request"
  );
} finally {
  setIsSubmitting(false);
  setLoading(false);
}
  };

  const handleAcceptTerms = () => {
    setShowTerms(false);
  };

  const inputStyle = {
    bg: "white",
    rounded: "lg",
    color: "#262636",
  };

  return (
    <SlideFade in={true} offsetX="-2000px">
      <>
        {isSubmitting && (
          <Modal isOpen={isSubmitting} onClose={() => {}} isCentered>
            <ModalOverlay />
            <ModalContent
              display="flex"
              justifyContent="center"
              alignItems="center"
              bg="transparent"
              shadow="none"
            >
              <Spinner size="xl" color={COLORS.green} />
              <Text mt={4} color="#fff" fontSize="1.4rem" fontWeight="900">
                Submitting... Please wait.
              </Text>
            </ModalContent>
          </Modal>
        )}

        <Modal 
          isOpen={showTerms} 
          onClose={() => {}} // Empty onClose to prevent closing by escape/clicking outside
          isCentered
        >
          <ModalOverlay />
          <ModalContent bg={COLORS.green} color="white" borderRadius="xl">
            <ModalHeader textAlign="center" fontSize="2xl">
              Important Notice
            </ModalHeader>
            <ModalBody p={8}>
              <Stack spacing={6} align="center" textAlign="center">
                <Icon as={AiOutlineInfoCircle} boxSize="12" />
                <Stack spacing={4}>
                  <Text fontSize="lg" fontWeight="bold">
                    Please Read Carefully
                  </Text>
                  <Text>
                    Before proceeding with your Access Card request, please note:
                  </Text>
                  <Stack spacing={3}>
                    <Text>
                      • You are only allowed to create TWO (2) Access Card per house
                    </Text>
                    <Text>
                      • The payment of ₦{serviceCharge} for the Access Card is NON-REFUNDABLE
                    </Text>
                    <Text>
                      • Multiple requests for the same person will be rejected
                    </Text>
                    <Text>
                      • Ensure all information provided is accurate as it will appear on your card
                    </Text>
                  </Stack>
                </Stack>
              </Stack>
            </ModalBody>
            <ModalFooter justifyContent="center" pb={6}>
              <Button
                bg="white"
                color={COLORS.green}
                _hover={{ bg: "gray.100" }}
                onClick={handleAcceptTerms}
                size="lg"
                w="200px"
              >
                I Understand
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </>
      <Box minH="100vh" pb="15vh">
        <Box shadow="sm">
          <Container>
            <Header />
          </Container>
        </Box>

        <Container minH="calc(100vh - 100px)">
          <Text fontWeight={"bold"} fontSize={"20px"} color={cardBg} mb={4} mt={4} textAlign={"center"}>
            Welcome!!!
          </Text>
          

          <Alert status="info" bg={COLORS.lightGrey} borderRadius="md" mb={4}>
            <AlertIcon />
            <AlertDescription display="flex" flexWrap="wrap" alignItems="center">
              Access Card requests require a
              <Text as="span" fontWeight="bold" whiteSpace="nowrap">
                &nbsp;NON-REFUNDABLE&nbsp;
              </Text>
              payment of
              <Text as="span" fontWeight="bold">
                &nbsp;₦{serviceCharge}
              </Text>
            </AlertDescription>
          </Alert>

          <FormControl h="100%" mt="30px">
            <Stack spacing="20px">
             

              <Box position="relative">
                <InputGroup>
                  <Select
                    {...inputStyle}
                    placeholder="Select Street"
                    value={formValues.streetId}
                    onChange={handleStreetChange}
                    isDisabled={loadingStreets}
                  >
                    {Object.entries(streetsData)
                      .sort(([, a], [, b]) => a.streetName.localeCompare(b.streetName))
                      .map(([id, { streetName }]) => (
                        <option key={id} value={id}>
                          {streetName}
                        </option>
                      ))}
                  </Select>
                </InputGroup>
                <Text
                  position="absolute"
                  top="-8px"
                  right="8px"
                  color="red.500"
                  fontWeight="600"
                  fontSize="24px"
                >
                  *
                </Text>
              </Box>

              <Box position="relative">
                <InputGroup>
                  
                  <Input
                  {...inputStyle}
                  placeholder="Enter House Address"
                  value={formValues.houseNumber}
                  name="houseNumber"
                  onChange={handleChange}
                />
                </InputGroup>
                <Text
                  position="absolute"
                  top="-8px"
                  right="8px"
                  color="red.500"
                  fontWeight="600"
                  fontSize="24px"
                >
                  *
                </Text>
              </Box>

                <Text color={cardBg} fontSize={"14px"} mb={2}>
                  Enter your name as you want it to appear on your card
                </Text>
              <Box position="relative">
                <Input
                  {...inputStyle}
                  placeholder="Full Name"
                  name="tenantName"
                  value={formValues.tenantName}
                  onChange={handleChange}
                />
                <Text
                  position="absolute"
                  top="-8px"
                  right="8px"
                  color="red.500"
                  fontWeight="600"
                  fontSize="24px"
                >
                  *
                </Text>
              </Box>

              <Box position="relative">
                <InputGroup>
                  <Input
                    {...inputStyle}
                    placeholder="Phone Number"
                    name="tenantPhone"
                    value={formValues.tenantPhone}
                    type="number"
                    onChange={handleChange}
                  />
                  <InputLeftElement children={<AiOutlinePhone />} />
                </InputGroup>
                <Text
                  position="absolute"
                  top="-8px"
                  right="8px"
                  color="red.500"
                  fontWeight="600"
                  fontSize="24px"
                >
                  *
                </Text>
              </Box>

              <Box position="relative">
                <Input
                  {...inputStyle}
                  placeholder="Email (Optional)"
                  name="email"
                  value={formValues.email}
                  type="email"
                  onChange={handleChange}
                />
              </Box>

              <Box>
                
                <FormLabel {...formLabelStyles}>
                  <HStack cursor="pointer">
                    <Text color={cardBg} fontWeight="500">
                      Upload passport photo
                    </Text>
                    <AiOutlineCloudUpload size={"1.5rem"} color={cardBg} />
                  </HStack>
                  <Text color={cardBg} fontSize="13px">
                    Ensure that the photo is clear, taken in a bright place and
                    your face is facing front, and fully visible.
                  </Text>
                  <Input
                    type="file"
                    accept="image/png, image/jpeg, image/jpg"
                    display="none"
                    id="media"
                    onChange={handleImage}
                  />
                </FormLabel>
              </Box>
              {media && (
                <Img
                  w="70px"
                  h="70px"
                  m="2"
                  borderRadius={"5px"}
                  src={URL.createObjectURL(media)}
                  alt="Passport"
                />
              )}
            </Stack>

            <HStack py="15px" justify="space-between" gap="1.5rem">
              <Stack
                {...inputStyle}
                textAlign="center"
                bg="#c7ebe2"
                px="15px"
                w="50%"
              >
                <Text as="small">Service Charge</Text>
                <Text fontSize="0.9rem" fontWeight="700" m="0 !important">
                  ₦{serviceCharge}
                </Text>
              </Stack>

              <ConfirmCardPayment
                allowToOpen={true}
                buttonProps={{
                  size: "md",
                  _hover: { background: `${COLORS.green}` },
                  _focus: { background: `${COLORS.green}` },
                  bg: `${COLORS.green}`,
                  p: "10px",
                  borderRadius: "10px",
                  color: "white",
                  w: "150px",
                  textAlign: "center",
                  btnText: "Pay",
                  isDisabled: !formValues.tenantName || !media || loading,
                }}
                btnTitle="Pay"
                addCloseModalBtn={true}
              >
                <Box color={cardBg}>
                  <Text fontWeight="bold" mb="4" fontSize={"1.5em"}>
                    Confirm Submission
                  </Text>
                  <Text mb="4">
                    Are you sure you want to submit this request?
                  </Text>
                  <PrimaryButton
                    size="md"
                    isLoading={paymentLoading}
                    btnText="Confirm"
                    onClick={() => {
                      setPaymentLoading(true);
                      axiosInstance
                        .post("/wallet/initialize-temp-payment", {
                          // amount: serviceCharge,
                          tenantName: formValues.tenantName,
                          email: formValues.email || "noemail@provided.com", // Provide fallback email since it's optional
                          phoneNumber: formValues.tenantPhone,
                          paymentFor: "card",
                          
                        })
                        .then((res) => {
                          const paymentInfo = res?.data?.result?.data;
                          setPaymentData(paymentInfo);
                          setConfirmModal(false);
                          setPaymentModal(true);
                        })
                        .catch((error) => {
                          errorNotifier(
    error.response?.data?.result?.message ||
    error.response?.data?.message ||
    error.message ||
    "Failed to initialize payment"
  );
                        })
                        .finally(() => {
                          setPaymentLoading(false);
                        });
                    }}
                  />
                </Box>
              </ConfirmCardPayment>
            </HStack>
          </FormControl>
        </Container>

        <PaystackModal
          paymentData={paymentData}
          paymentModal={paymentModal}
          setPaymentModal={setPaymentModal}
          onFinish={() => {
            setIsSubmitting(true);

            axiosInstance
              .post("/wallet/verify-temp-card-payment", {
                reference: paymentData?.reference,
              })
              .then(() => {
                successNotifier("Payment Successful");
                handleSubmit();
              })
              .catch((error) => {
                errorNotifier(
                  error.response?.data?.message ||
                    "Payment verification failed"
                );
              })
              .finally(() => {
                setIsSubmitting(false);
              });
          }}
          onClose={onClose}
        />
      </Box>
    </SlideFade>
  );
};

export default RequestId;
